import http from '../api/http';

export default {
    signUpWithXero({params, callback}){
        http.post(`/v1/xero/signUpWithXero?isPro=${params.isPro}`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getProfileInfo({params, callback}){
        http.post(`/v1/xero/getProfileInfo?code=${params.code}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getTrackingCategories({callback}){
        http.get('/v1/xero/getTrackingCategories').then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    saveTrackingCategories({params, callback}){
        http.post('/v1/xero/saveTrackingCategories', params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    async signUpaccountAddApi(params){
        const res = await http.post(`/v1/appAccount/account-add`, params)
        return res
    },

}


// WEBPACK FOOTER //
// ./src/api/xero.js